import { put } from 'redux-saga/effects';
import { Notifications } from 'types';

import { OnScannedCardsData } from '../types';
import { saveDrawResultToStoreAction } from 'core/widgets/DrawResult/actions';

export function* onScannedCardsSaga({ type: notificationType, data: result }: OnScannedCardsData) {
  if (notificationType === Notifications.SCANNED_CARDS) {
    const { cards, playerTotal, bankerTotal } = result;
    yield put(
      saveDrawResultToStoreAction({ cards, points: { player: playerTotal, banker: bankerTotal } }),
    );
  }
}
